import { currencyFormat } from "../helpers.js";

/** Shared annual revenue and operating-cost ladder. Values are whole dollars. */
export const MONEY_AMOUNT_STEP = 100000;
export const MONEY_AMOUNT_MAX = 50000000;

export const MONEY_AMOUNT_OPTIONS = (() => {
  const options = [];
  for (let value = 0; value <= MONEY_AMOUNT_MAX; value += MONEY_AMOUNT_STEP) {
    options.push({ value, label: currencyFormat(value) });
  }
  return options;
})();

/** Whole-dollar amount, or null when the field is empty or not numeric. */
export function moneyAmountToInteger(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number") {
    return Number.isFinite(value) ? Math.round(value) : null;
  }

  const raw = String(value).trim();
  if (!raw) return null;
  const numeric = Number(raw.replace(/[$,\s]/g, ""));
  if (!Number.isFinite(numeric)) return null;
  return Math.round(numeric);
}

/** Keep an off-ladder stored amount visible so it is not shown as blank. */
export function moneyAmountOptionsForValue(value, options = MONEY_AMOUNT_OPTIONS) {
  const amount = moneyAmountToInteger(value);
  if (amount == null || options.some((option) => option.value === amount)) return options;

  const extra = { value: amount, label: currencyFormat(amount) };
  const next = options.slice();
  const insertAt = next.findIndex((option) => option.value > amount);
  if (insertAt === -1) next.push(extra);
  else next.splice(insertAt, 0, extra);
  return next;
}
